exports.Resource = require('./resource');

exports.Attachments = require('./attachments');
exports.CustomFieldSettings = require('./custom_field_settings');
exports.CustomFields = require('./custom_fields');
exports.Events = require('./events');
exports.Jobs = require('./jobs');
exports.OrganizationExports = require('./organization_exports');
exports.Projects = require('./projects');
exports.PortfolioMemberships = require('./portfolio_memberships');
exports.Portfolios = require('./portfolios');
exports.ProjectMemberships = require('./project_memberships');
exports.ProjectStatuses = require('./project_statuses');
exports.Sections = require('./sections');
exports.Stories = require('./stories');
exports.Tags = require('./tags');
exports.Tasks = require('./tasks');
exports.Teams = require('./teams');
exports.Users = require('./users');
exports.UserTaskLists = require('./user_task_lists');
exports.Workspaces = require('./workspaces');
exports.Webhooks = require('./webhooks');



//////////////////
// WEBPACK FOOTER
// ./node_modules/asana/lib/resources/index.js
// module id = 586
// module chunks = 0